import styled from 'styled-components'
// views
import { UserWrapper } from 'components/FormElements/UsersList/views'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;

  > :last-child {
    margin-top: auto;
    padding-top: 20px;
  }

  ${UserWrapper} {
    & > div:first-child {
      max-width: 100%;
    }
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding-right: 16px;
`
